import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { api } from "../lib/api";
import { Avatar } from "./Avatar";

export const PersonCard = ({ c, id }) => (
  <li className={`min-w-0 overflow-hidden rounded-xl border p-2.5 sm:p-3 flex items-center gap-2 sm:gap-3 ${c.stesso_orario ? "border-[var(--teal)] bg-[var(--teal-soft)]" : "border-slate-200"}`} data-testid={`${id}-card`}>
    <Avatar src={c.foto || ""} className="hidden min-[400px]:flex" testid={`${id}-avatar`} />
    <div className="min-w-0 flex-1"><p className="font-semibold text-[var(--navy)] truncate">{c.nome}</p>
      <p className="text-xs text-slate-500 truncate">{c.orario}{c.mansioni.length ? ` · ${c.mansioni.join(", ")}` : ""}</p></div>
    {c.telefono ? (
      <div className="ml-auto flex gap-1.5 shrink-0">
        <a href={`tel:+${c.telefono}`} aria-label={`Chiama ${c.nome}`} className="w-9 h-9 rounded-full bg-[var(--teal)] text-white flex items-center justify-center hover:scale-105 transition-transform" data-testid={`${id}-call`}><Phone className="w-4 h-4" /></a>
        <a href={`https://wa.me/${c.telefono}`} target="_blank" rel="noreferrer" aria-label={`WhatsApp a ${c.nome}`} className="w-9 h-9 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:scale-105 transition-transform" data-testid={`${id}-whatsapp`}><MessageCircle className="w-4 h-4" /></a>
      </div>) : <span className="ml-auto text-[11px] text-slate-400 shrink-0" data-testid={`${id}-no-phone`}>Nessun numero</span>}
  </li>
);

export const PersonGrid = ({ people, prefix }) => (
  <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid={`${prefix}-list`}>
    {people.map((c, i) => <PersonCard key={i} c={c} id={`${prefix}-${i}`} />)}
  </ul>
);

export function OnShiftToday() {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("Mare");
  useEffect(() => { api("/web/on-shift-all").then(setD).catch(() => setD({ reparti: [], errore: true })); }, []);
  const cur = d?.reparti?.find((r) => r.reparto === tab);
  return (
    <section className="mb-12 fade-up" data-testid="on-shift-today">
      <h2 className="font-display text-xl font-bold text-[var(--navy)] mb-4">Chi è di turno oggi</h2>
      <div className="flex gap-2 mb-3" role="tablist">
        {["Mare", "Uffici"].map((r) => {
          const n = d?.reparti?.find((x) => x.reparto === r)?.persone.length;
          return (
            <button key={r} role="tab" aria-selected={tab === r} onClick={() => setTab(r)} data-testid={`on-shift-tab-${r.toLowerCase()}`}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${tab === r ? "bg-[var(--navy)] text-white" : "bg-white border border-slate-200 text-[var(--navy)] hover:bg-slate-50"}`}>
              {r}{n !== undefined && <span className={`ml-2 text-xs ${tab === r ? "text-white/70" : "text-slate-400"}`}>{n}</span>}
            </button>);
        })}
      </div>
      <div className="panel !p-3 sm:!p-5" data-testid={`on-shift-today-${tab.toLowerCase()}`}>
        {d === null ? <p className="text-sm text-slate-500">Caricamento…</p> : d.errore ? <p className="text-sm text-slate-500" data-testid="on-shift-today-error">Turni di oggi momentaneamente non disponibili, riprova tra poco.</p>
          : cur?.persone.length ? <PersonGrid people={cur.persone} prefix={`today-${tab.toLowerCase()}`} /> : <p className="text-sm text-slate-500" data-testid="on-shift-today-empty">Nessuno di turno oggi.</p>}
      </div>
    </section>
  );
}
